<template>
  <div>
    <Top />
    <div class="menu" v-if="windowWidth > 769">
      <div class="home clearfix">
        <div class="subnav1 fl">
          <i></i>
          <span>领域分类</span>
          <div class="down_btn1 fr" @click="fieldSortsShow">
            <a href="javascript:;">
              <img src="@/assets/imgs/down.png" />
            </a>
          </div>
          <div class="main_left fl" ref="fieldSorts">
            <div style="margin: 10px 30px">
              <div
                class="linecss"
                v-for="fieldItem in fieldSorts"
                :key="fieldItem.uid"
              >
                <div class="clearfix" style="width: 215px">
                  <h2 class="icon icon_css fl">{{ fieldItem.text }}</h2>
                  <img
                    src="@/assets/imgs/rightbtn.png"
                    class="fr"
                    style="margin-top: 9px"
                  />
                </div>
                <ul>
                  <li v-for="item in fieldItem.newChildren" :key="item.uid">
                    <router-link
                      :to="{
                        path: '/allReports',
                        query: { id: item.uid, idname: item.text },
                      }"
                      @click.native="getFieldname(item.text)"
                      v-show="item.isPresent"
                      >{{ item.text }}</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <ul class="fr ul1">
          <li class="menu_li">
            <router-link
              :to="{ path: '/weekReport', query: { uid: '全部报告' } }"
              class="navtxt"
              :class="{ navtxtHover: this.$route.query.uid === '全部报告' }"
              style="border-left: 1px solid #025f93"
              >全部报告</router-link
            >
          </li>
          <li class="menu_li">
            <router-link
              :to="{ name: 'weekReport', query: { uid: '周评' } }"
              class="navtxt"
              :class="{
                navtxtHover:
                  this.$route.query.uid === '周评' &&
                  this.$route.name !== 'allReport',
              }"
              >周评</router-link
            >
          </li>
          <li class="menu_li">
            <router-link
              :to="{ name: 'weekReport', query: { uid: '月度报告' } }"
              class="navtxt"
              :class="{
                navtxtHover:
                  this.$route.query.uid === '月度报告' &&
                  this.$route.name !== 'allReport',
              }"
              >月度报告</router-link
            >
          </li>
          <li class="menu_li">
            <router-link
              :to="{ name: 'weekReport', query: { uid: '季度报告' } }"
              class="navtxt"
              :class="{
                navtxtHover:
                  this.$route.query.uid === '季度报告' &&
                  this.$route.name !== 'allReport',
              }"
              >季度报告</router-link
            >
          </li>
          <li class="menu_li">
            <router-link
              :to="{ name: 'yearReport', query: { uid: '年度报告' } }"
              class="navtxt"
              :class="{
                navtxtHover:
                  this.$route.query.uid === '年度报告' &&
                  this.$route.name !== 'allReport',
              }"
              >年度报告</router-link
            >
          </li>
          <li class="menu_li">
            <router-link
              :to="{ name: 'weekReport', query: { uid: '热点报告' } }"
              class="navtxt"
              :class="{
                navtxtHover:
                  this.$route.query.uid === '热点报告' &&
                  this.$route.name !== 'allReport',
              }"
              >热点报告</router-link
            >
          </li>
          <li class="menu_li">
            <a
              href="javascript:;"
              class="navtxt"
              :class="{ navtxtHover: this.$route.name === 'specialReport' }"
              >专题报告</a
            >
            <ul class="nav_cd" style="left: 609px; text-align: center">
              <li
                v-for="item in topicMenu"
                :key="item.uid"
                v-if="item.apptext === '互联网金融'"
              >
                <router-link
                  :to="{
                    path: '/specialReport',
                    query: { uid: item.apptext, id: item.uid },
                  }"
                  >{{ item.apptext }}</router-link
                >
              </li>
              <li>
                <a
                  :href="
                    indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26276&docid=3684000&uid=900103&version=dReport&imgShowType=1'
                  "
                  target="_blank"
                  >智慧城市</a
                >
              </li>
              <li>
                <a
                  :href="
                    indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26277&docid=5783244&uid=900104&version=dReport&imgShowType=1'
                  "
                  target="_blank"
                  >金融科技</a
                >
              </li>
              <li>
                <a
                  :href="
                    indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26278&docid=5778059&uid=900105&version=dReport&imgShowType=1'
                  "
                  target="_blank"
                  >大数据</a
                >
              </li>
              <li>
                <a
                  :href="
                    indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=27053&docid=6011076&uid=900107&version=dReport&imgShowType=1'
                  "
                  target="_blank"
                  >数字经济指数</a
                >
              </li>
              <li>
                <a
                  :href="
                    indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=06501&leafid=27054&docid=6013634&uid=900108&version=dReport&imgShowType=1'
                  "
                  target="_blank"
                  >绿色金融指数</a
                >
              </li>
            </ul>
          </li>
          <li class="menu_li">
            <router-link
              :to="{ name: 'home' }"
              class="navtxt"
              style="color: #ffff00"
              >回到首页</router-link
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- 文章 -->
    <div class="content home clearfix">
      <div class="location">
        当前位置：
        <router-link class="a" :to="{ path: '/' }">首页</router-link
        >&nbsp;&gt;&nbsp;
        <a class="a" href="javascript:;">专题报告</a>&nbsp;&gt;&nbsp;
        <a class="a" href="javascript:;">{{ currentReportUid }}</a>
      </div>

      <div class="zt_main">
        <div class="title_text">
          <h2>{{ currentReportUid }}</h2>
        </div>

        <div class="box_kj clearfix" v-for="item in docsData" :key="item.code">
          <div class="left_img fl">
            <img
              :src="
                indexImgURL +
                '/www/ydyl/ImageShow.ashx?docId=' +
                (item.code || '').substring(4, (item.code || '').length) +
                '&purposeId=2'
              "
            />
            <p>{{ item.title }}</p>
          </div>
          <div class="right_text fr">
            <div class="a">
              <p>{{ item.summary }}</p>
              <div class="timecss clearfix">
                <span class="fl">{{ item.deliveddate }}</span>
                <a
                  :href="
                    indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                    item.chnid +
                    '&leafid=' +
                    item.leafid +
                    '&docid=' +
                    (item.code || '').substring(4, (item.code || '').length) +
                    '&uid=' +
                    item.uid +
                    '&version=dReport'
                  "
                  target="_blank"
                  class="more_zt fr"
                  >了解更多</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="y-pagination" v-if="windowWidth > 769">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="7"
          :current-page="currentPage"
          layout="prev, pager, next, jumper, total"
          :total="total"
        ></el-pagination>
      </div>
      <div class="y-pagination" v-if="windowWidth < 769"  style="margin:16px auto;width:251px">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="7"
          :current-page="currentPage"
          layout="prev, pager, next"
          small
          :pager-count="5"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/Top";
import Footer from "@/components/Footer";
import { api } from "@/pages/index/require/api.js";
import { setFieldname } from "@/pages/index/require/auth";
export default {
  components: {
    Top,
    Footer,
  },
  data() {
    return {
      topicMenu: [],
      fieldSorts: [],
      currentReportUid: "",
      currentId: "",
      docsData: [],
      currentPage: 1,
      total: 0,
      indexLinkURL: window.indexLinkURL,
      indexImgURL: window.indexImgURL,
    };
  },
  created() {
    
    this.currentReportUid = this.$route.query.uid;
    this.currentId = this.$route.query.id;
    this.currentPage = 1;
    this.loadsubmenu();
    this.loadDocs();
    this.loadFieldSorts();
  },
  watch: {
    $route() {
      this.currentReportUid = this.$route.query.uid;
      this.currentId = this.$route.query.id;
      this.currentPage = 1;
      this.loadDocs();
    },
  },
  methods: {
    async loadsubmenu() {
      const { code, data } = await api.get(
        "/indexController/getChildSpecialChanels"
      );
      if (code === 0) {
        this.topicMenu = data.children;
      }
    },
    fieldSortsShow: function () {
      var height = this.$refs.fieldSorts.style.height;
      if (height === "") height = "0px";
      if (height == "0px") {
        this.$refs.fieldSorts.style.height = "1970px";
      } else {
        this.$refs.fieldSorts.style.height = "0px";
      }
    },
    getFieldname(val) {
      setFieldname(val);
    },
    async loadFieldSorts() {
      const { code, data } = await api.get("/indexController/getFieldSorts");
      if (code === 0) {
        this.fieldSorts = data;
      }
    },
    async loadDocs() {
      const { code, data } = await api.get(
        "/indexController/getSpecilDocsByUid",
        {
          uid: this.currentId,
          curpage: this.currentPage,
          pagesize: 7,
          time: new Date().getTime(),
        }
      );
      this.docsData = [];
      this.total = 0;
      if (code === 0) {
        this.docsData = data.data;
        this.total = data.totlalCount;
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadDocs();
    },
  },
};
</script>

<style lang='less' scoped>
.menu {
  height: 45px;
  line-height: 43px;
  background: #0770b9;
  .ul1 {
    position: relative;
    .menu_li {
      float: left;
      border-right: 1px solid #025f93;
      .navtxt {
        color: #fff;
        padding: 0 20px;
        font-size: 17px;
        height: 45px;
        display: block;
      }
      .navtxt:hover {
        background: #1399ee;
      }
    }
    .menu_li:last-child:hover .nav_cd {
      display: block;
    }
    .menu_li:nth-child(7):hover .nav_cd {
      display: block;
    }
  }
  .subnav1 {
    position: relative;
    height: 45px;
    background: #015d9e;
    width: 270px;
    i {
      background: url(../../../assets/imgs/cdimg.png) no-repeat;
      width: 17px;
      height: 14px;
      display: block;
      float: left;
      margin-left: 20px;
      margin-top: 16px;
      margin-right: 15px;
    }
    span {
      color: #fff;
      font-size: 17px;
    }
    img {
      height: auto;
      width: auto;
      margin-right: 23px;
      margin-top: 16px;
    }
  }
}
.main_left {
  width: 270px;
  border-top: none;
  position: absolute;
  z-index: 999;
  background: #0770b9;
  opacity: 0.9;
  box-shadow: 0px 0px 11px #015d9e;
  overflow: hidden;
  transition: all 0.8s ease;
  height: 0px;
  .linecss {
    border-left: 1px dashed #a4a4a4;
    margin-left: 10px;
  }
  ul {
    padding-bottom: 10px;
  }
  li {
    line-height: 20px;
  }
  ul a {
    padding-left: 24px;
    color: #fff;
    font-size: 15px;
    line-height: 30px;
  }
  li:hover a {
    color: rgb(255, 255, 0);
    cursor: pointer;
  }
}
.nav_cd {
  display: none;
  padding: 15px 25px;
  background: rgba(0, 52, 122, 0.9);
  border-bottom: #1d9bec 4px solid;
  position: absolute;
  z-index: 1;
  font-size: 15px;
  li {
    border-bottom: 1px dashed #5473a1;
    a {
      color: #edf5ff;
      display: inline-block;
    }
    a:hover {
      color: #ffff00 !important;
    }
  }
}
.zt_main {
  .title_text {
    background: url(../../../assets/imgs/line.jpg) no-repeat bottom;
    width: 100%;
    margin-bottom: 40px;
    h2 {
      font-size: 26px;
      font-weight: bold;
      text-align: center;
      padding-bottom: 30px;
      padding-top: 20px;
    }
  }
  .box_kj {
    margin: 15px 0 30px 0;
    border-bottom: 1px solid #cecece;
    padding-bottom: 30px;
    .left_img {
      width: 315px;
      height: 185px;
      position: relative;
      p {
        position: absolute;
        bottom: 0;
        background: rgba(17, 38, 119, 0.6);
        width: 100%;
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: #fff;
        font-size: 15px;
      }
    }
    .right_text {
      width: 855px;
      position: relative;
      height: 185px;
      .a {
        color: #333;
        font-size: 15px;
        padding-top: 10px;
        display: block;
        line-height: 27px;
        text-align: justify;
        .timecss {
          position: absolute;
          bottom: 5px;
          width: 100%;
          span {
            display: block;
            color: #a29c9c;
          }
          .more_zt {
            color: #0779b9;
            border: #0779b9 1px solid;
            border-radius: 100px;
            padding: 0px 20px;
            cursor: pointer;
          }
          .more_zt:hover {
            color: #fff;
            background: #0779b9;
          }
        }
      }
    }
  }
}
img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.navtxtHover {
  background: #1399ee;
}
.y-pagination {
  float: right;
  font-family: "microsoft yahei";
  font-size: 12px;
  margin: 30px 0;
  padding-bottom: 20px;
}
/deep/.el-pagination__jump {
  margin: 0 24px;
}
@media screen and (max-width: 769px) {
  .zt_main {
    padding: 0 8px;
    .box_kj {
      .left_img {
        width: 175px;
        height: 150px;
      }
      .right_text {
        width: calc(100% - 175px);
        height: 150px;
        padding-left: 12px;
        .a {
          padding-top: 0;
          p {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .more_zt {
            font-size: 12px;
          }
          .timecss {
            position: relative !important;
            margin-top: 40px;
          }
        }
      }
    }
  }
}
</style>